import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/styles';
import { AddCircleRounded } from '@mui/icons-material';
import ButtonInc from '../../../../../../shared-ui/ButtonInc';
import { getPartner } from '../../../../../../lib/access.es6';
import { canRemoveMember } from '../utils/memberHelpers';

const useStyles = makeStyles(() => ({
  dependantWrapper: {
    '& table': {
      width: '100%',
      background: '#FFFFFF',
      border: '1px solid #A7A7A7',
      marginBottom: '20px',
      '& tr': {
        borderTop: '1px solid #A7A7A7',
      },
      '& th': {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '12px',
        lineHeight: '15px',
        color: '#000000',
        padding: '10px',
        borderRight: '1px solid #A7A7A7',
      },
      '& td': {
        fontFamily: 'open sans',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '12px',
        lineHeight: '15px',
        color: '#000000',
        padding: '10px',
        borderRight: '1px solid #A7A7A7',
      }
    }
  }
}));

const MemberSelectionTable = ({
  members,
  onRemove,
  onAdd,
  title,
  showTotal,
  totalPremium,
  isRemovedTable = false,
  showAddButton = false,
  addedMemberUuids = [],
  onCancelAdded
}) => {
  const classes = useStyles();
  const currencyCode = getPartner().country.currency_code;

  // Show section if there are members OR if showAddButton is true (to allow adding first member)
  if ((!members || members.length === 0) && !showAddButton) {
    return null;
  }

  const hasMembers = members && members.length > 0;

  const handleRemoveClick = (member) => {
    if (!isRemovedTable) {
      const check = canRemoveMember(member);
      if (!check.canRemove) {
        return;
      }
    }
    onRemove(member.uuid);
  };

  return (
    <section style={{
      marginBottom: '30px',
      ...(isRemovedTable && {
        backgroundColor: '#fff3cd',
        padding: '15px',
        borderRadius: '8px',
        border: '1px solid #ffc107'
      })
    }}>
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <h6>{title}</h6>
        </Grid>
        <Grid item xs={3} style={{ textAlign: 'left', marginTop: '2px' }}>
          {showAddButton && onAdd && (
            <AddCircleRounded
              style={{ cursor: 'pointer', margin: 0, color: '#032A37' }}
              onClick={onAdd}
            />
          )}
        </Grid>
        <Grid item xs={6} style={{ textAlign: 'right', marginTop: '2px' }}>
          {showTotal && hasMembers && (
            <h6 style={{ textAlign: 'right' }}>
              Total Premium: {currencyCode} {(totalPremium / 100).toFixed(2)}
            </h6>
          )}
        </Grid>

        {hasMembers && (
          <Grid item xs={12} sm={12} md={12}>
            <div className={classes.dependantWrapper}>
              <table>
                <thead>
                  <tr>
                    <th>Member Name</th>
                    <th>Relationship</th>
                    <th>Benefits</th>
                    <th>Premium</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {members.map((member, index) => {
                  const check = canRemoveMember(member);
                  const isAddedMember = addedMemberUuids.includes(member.uuid);

                  return (
                    <tr
                      key={member.uuid || index}
                      style={isAddedMember ? { backgroundColor: '#d4edda' } : {}}
                    >
                      <td>
                        {member.first_name} {member.last_name}
                        {!isRemovedTable && !check.canRemove && (
                          <div style={{ fontSize: '10px', color: '#856404', marginTop: '4px' }}>
                            (Cannot remove)
                          </div>
                        )}
                      </td>
                      <td>{member.relationship}</td>
                      <td>
                        <ul style={{ margin: 0, paddingLeft: 0, listStyle: 'none' }}>
                          {member.benefits && member.benefits.map((benefit, i) => {
                            // Premium can be in multiple locations depending on benefit type
                            const premiumAmount = benefit.premium_amount
                              || benefit.premium_amount_in_cents
                              || (benefit.additional_details && benefit.additional_details.premium_amount)
                              || 0;

                            return (
                              <li key={i} style={{ marginBottom: '4px' }}>
                                {benefit.type ? benefit.type.toLowerCase() : benefit.name}{' '}
                                <strong>
                                  {currencyCode} {((benefit.cover_amount_in_cents || benefit.benefit_amount_in_cents || 0) / 100).toLocaleString()}
                                  {' '}({currencyCode} {(premiumAmount / 100).toFixed(2)})
                                </strong>
                              </li>
                            );
                          })}
                        </ul>
                      </td>
                      <td style={{ textAlign: 'right', fontWeight: '600' }}>
                        {currencyCode} {((member.premium_amount_in_cents || 0) / 100).toFixed(2)}
                      </td>
                      <td>
                        {isRemovedTable ? (
                          <ButtonInc
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleRemoveClick(member)}
                          >
                            reinstate
                          </ButtonInc>
                        ) : isAddedMember ? (
                          <ButtonInc
                            style={{ cursor: 'pointer' }}
                            onClick={() => onCancelAdded(member.uuid)}
                          >
                            cancel
                          </ButtonInc>
                        ) : (
                          check.canRemove ? (
                            <ButtonInc
                              style={{ cursor: 'pointer' }}
                              onClick={() => handleRemoveClick(member)}
                            >
                              remove member
                            </ButtonInc>
                          ) : (
                            <span style={{ color: '#999', fontSize: '11px' }}>Protected</span>
                          )
                        )}
                      </td>
                    </tr>
                  );
                  })}
                </tbody>
              </table>
            </div>
          </Grid>
        )}
      </Grid>
    </section>
  );
};

export default MemberSelectionTable;
